import api from '../../services/api';

const state = {
  tiers: [],
  loading: false,
};

const getters = {
  allTiers: s => s.tiers,
  isLoading: s => s.loading,
};

const actions = {
  async fetchTiers({ commit }) {
    commit('SET_LOADING', true);
    try {
      const res = await api.get('/tiers');
      commit('SET_TIERS', res.data);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to fetch tiers' };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async createTier({ dispatch }, data) {
    try {
      const res = await api.post('/tiers', data);
      await dispatch('fetchTiers');
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to create' };
    }
  },

  async updateTier({ dispatch }, { id, data }) {
    try {
      const res = await api.put(`/tiers/${id}`, data);
      await dispatch('fetchTiers');
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to update' };
    }
  },

  async deleteTier({ dispatch }, id) {
    try {
      await api.delete(`/tiers/${id}`);
      await dispatch('fetchTiers');
      return { success: true };
    } catch (err) {
      return {
        success: false,
        error: err.response?.data?.message || err.response?.data?.error || 'Failed to delete',
      };
    }
  },
};

const mutations = {
  SET_TIERS(s, v) { s.tiers = v; },
  SET_LOADING(s, v) { s.loading = v; },
};

export default { namespaced: true, state, getters, actions, mutations };
